const request = require('superagent')
const inject = require('injectinto')
const { PublicClientApplication, InteractionRequiredAuthError } = require('@azure/msal-browser')
const subdomain = require('./subdomain')
const page = require('page')

const get = key => {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (e) {
    return null
  }
}
const set = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
  return value
}

const getazureadvariableslocal = () => ({
  AD_AUTHORITY: get('AD_AUTHORITY'),
  AD_CLIENT_ID: get('AD_CLIENT_ID'),
  AD_TENANT_ID: get('AD_TENANT_ID')
})

const getazureadvariables = async emaildomain => {
  const { AD_AUTHORITY, AD_CLIENT_ID, AD_TENANT_ID } = getazureadvariableslocal()
  if (AD_AUTHORITY && AD_CLIENT_ID && AD_TENANT_ID) return { AD_AUTHORITY, AD_CLIENT_ID, AD_TENANT_ID }

  if (!emaildomain) return null

  return await new Promise((resolve, reject) => {
    try {
      request
        .get(`/auth/variables/${emaildomain}`)
        .send()
        .end((err, res) => {
          if (err != null) return alert(err)
          if (!res.ok) return alert(res.text)

          const { variables } = res.body
          const { AD_AUTHORITY, AD_CLIENT_ID, AD_TENANT_ID } = variables
          set('AD_AUTHORITY', AD_AUTHORITY)
          set('AD_CLIENT_ID', AD_CLIENT_ID)
          set('AD_TENANT_ID', AD_TENANT_ID)
          resolve({ AD_AUTHORITY, AD_CLIENT_ID, AD_TENANT_ID })
        })
    } catch (e) {
      console.error(e)
      reject(e)
    }
  })
}

module.exports = (hub, scene, localstore) => {
  let authtype = get('authtype') ?? 'classic'
  let emaildomain = get('emaildomain')
  let app = null
  let account = get('account')

  const genazureapp = async emaildomain =>
    await new Promise((resolve, reject) => {
      try {
        getazureadvariables(emaildomain).then(({ AD_AUTHORITY, AD_CLIENT_ID, AD_TENANT_ID }) => {
          app = new PublicClientApplication({
            auth: {
              clientId: AD_CLIENT_ID,
              authority: `https://${AD_AUTHORITY}/${AD_TENANT_ID}/`,
              redirectUri: `${window.location.protocol}//${window.location.host}/sso/azure-ad/`
            },
            cache: {
              cacheLocation: 'localStorage',
              storeAuthStateInCookie: false
            }
          })
          app.initialize().then(() => resolve(app))
        })
      } catch (e) {
        console.error(e)
        reject(e)
      }
    })

  // If page refreshes, and we have a email domain recorded (signaling we are signed in), we need to re-initialize the app
  if (authtype == 'azure-ad' && emaildomain) genazureapp(emaildomain)

  // Inject the query guard for requests using fetch
  inject('query fetch', async fn => {
    const headers = new Headers()
    headers.append('X-AuthType', authtype)
    headers.append('X-EmailDomain', emaildomain)

    if (authtype == 'classic') return await fn({ headers })

    if (!account) return null

    let accesstoken = null
    const params = {
      scopes: JSON.parse('["access_as_user"]').map(scope => `api://${get('AD_CLIENT_ID')}/${scope}`),
      account
    }
    try {
      const { accessToken } = await app.acquireTokenSilent(params)
      accesstoken = accessToken
    } catch (e) {
      if (!(e instanceof InteractionRequiredAuthError)) throw e
    }
    if (!accesstoken) {
      try {
        const { accessToken } = await app.acquireTokenRedirect(params)
        accesstoken = accessToken
      } catch (e) {
        throw e
      }
    }

    if (accesstoken) {
      return await fn({
        accessToken: accesstoken,
        headers: {
          'X-AuthType': authtype,
          'X-EmailDomain': emaildomain,
          Authorization: `Bearer ${accesstoken}`
        }
      })
    }
  })

  // Used like: inject.one('query superagent', request.post().send({}), (err, res) => {})
  inject('query superagent', (request, cb) => {
    if (authtype == 'classic')
      return request
        .set('X-AuthType', authtype)
        .set('X-EmailDomain', emaildomain)
        .end((err, res) => (err ? cb(err) : cb(null, res)))

    if (!account) return null

    const send = accesstoken =>
      request
        .set('Authorization', `Bearer ${accesstoken}`)
        .set('X-AuthType', authtype)
        .set('X-EmailDomain', emaildomain)
        .end((err, res) => (err ? cb(err) : cb(null, res)))

    const params = {
      scopes: [...JSON.parse('["access_as_user"]').map(scope => `api://${get('AD_CLIENT_ID')}/${scope}`)],
      account
    }

    app
      .acquireTokenSilent(params)
      .then(({ accessToken }) => send(accessToken))
      .catch(e => {
        if (!(e instanceof InteractionRequiredAuthError)) return cb(e)
        app
          .acquireTokenRedirect(params)
          .then(({ accessToken }) => send(accessToken))
          .catch(e => cb(e))
      })
  })

  inject(
    'can i',
    (state, permission) =>
      state.identity.permissions.indexOf('superpowers') >= 0 ||
      state.identity.permissions.indexOf(`portfolio/${state.portfolio.portfolio_id}/${permission}`) >= 0
  )

  hub.every('azure auth login', async (params, cb) => {
    const { type, email, redirect } = params
    authtype = set('authtype', type)
    emaildomain = set('emaildomain', email.split('@')[1])

    await genazureapp(emaildomain)
    await app.handleRedirectPromise()

    const accounts = app.getAllAccounts()
    if (accounts.length == 0) return await app.loginRedirect({ loginHint: email })

    account = accounts.find(({ username }) => username.toLowerCase() == email.toLowerCase())
    set('account', account)
    if (!account) return await app.loginRedirect({ loginHint: email })

    inject.one('query superagent')(request.post('/auth/sso/complete').send({ email }), (err, res) => {
      if (err) return alert(err)
      if (redirect) return page(redirect)
      return page('/login/complete')
    })
  })

  // Handle token from redirect
  return hub.every('azure auth callback', async (params, cb) => {
    try {
      if (!app) await genazureapp(emaildomain)
      await app.handleRedirectPromise()
    } catch (e) {
      console.error(e)
    }
  })
}
